import axios from 'axios';

export const qrPublicApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/qr-public`,
    headers: {
        'Content-Type': 'application/json'
    }
})